var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaypal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paypal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4796 14.3406L19.4848 14.3427C19.5932 13.8812 19.9869 13.5417 20.4796 13.5417H34.513C34.5307 13.5417 34.5484 13.5344 34.5661 13.5354C34.2671 8.55729 30.0911 6.25 26.4067 6.25H12.3734C11.8796 6.25 11.4859 6.59896 11.3786 7.05937L11.3734 7.05729L5.239 35.2219L5.25254 35.2229C5.23796 35.2896 5.21191 35.3531 5.21191 35.425C5.21191 36.001 5.67754 36.4573 6.25358 36.4573H14.6609L19.4796 14.3406Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.5652 13.5354C34.6204 14.4479 34.56 15.4406 34.3267 16.5375C32.9923 22.7823 28.1684 26.0323 22.2069 26.0323C22.2069 26.0323 18.5923 26.0323 17.7142 26.0323C17.1715 26.0323 16.9152 26.351 16.7975 26.5948L14.985 34.9792L14.6673 36.4677H14.6611L13.3454 42.5052L13.359 42.5062C13.3444 42.5729 13.3184 42.6364 13.3184 42.7083C13.3184 43.2844 13.784 43.75 14.36 43.75H21.9986L22.0121 43.7396C22.5038 43.7323 22.8944 43.3812 22.9965 42.9187L23.0152 42.9031L24.9027 34.1364C24.9027 34.1364 25.034 33.3 25.9132 33.3C26.7923 33.3 30.2652 33.3 30.2652 33.3C36.2267 33.3 41.0996 30.0646 42.435 23.8187C43.9371 16.7771 38.9142 13.5614 34.5652 13.5354Z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.4792 13.5417C19.9854 13.5417 19.5917 13.8813 19.4844 14.3428L19.4792 14.3407L16.7969 26.5959C16.9146 26.3521 17.1708 26.0334 17.7135 26.0334C18.5927 26.0334 22.125 26.0334 22.125 26.0334C28.0865 26.0334 32.9917 22.7834 34.326 16.5386C34.5604 15.4417 34.6198 14.449 34.5646 13.5365C34.5479 13.5344 34.5292 13.5417 34.5125 13.5417H20.4792Z",
    fill: "#283593"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/Paypal.a8eee6837282fb21e90d72f006562f6e.svg";
export { ForwardRef as ReactComponent };